import React from "react";
import "../lifehacks/ArticleFull.css";

const BetoCarreroArticle = () => {
  return (
    <article className="article-full">
      <h1 className="article-title">
        🎢 Beto Carrero World: лучший парк аттракционов в Бразилии и лайфхаки для идеального дня
      </h1>
      <p className="article-text">
        Если вы в Бразилии и ищете, чем порадовать детей (и себя!), то Beto Carrero World — это must-visit.
        Это крупнейший тематический парк в Латинской Америке, расположенный в городе Пенха (Penha),
        штат Санта-Катарина, примерно в 2,5 часах от Флорипы. Здесь вас ждут американские горки, зоопарк,
        шоу в стиле Голливуда и атмосфера настоящего приключения.
      </p>

      <section className="article-section">
        <h2 className="article-subtitle">🗺 Где находится и как добраться</h2>
        <p className="article-section-info">📍 Penha, SC</p>
        <p className="article-text">🚗 Из Флорипы:</p>
        <p className="article-section-info">
          На машине — около 2,5 часов по BR-101.
        </p>
        <p className="article-section-info">
          На автобусе — прямых рейсов нет, но можно доехать до ближайших городов (например, Navegantes)
          и взять такси или трансфер.
        </p>
        <p className="article-section-info">✈️ Ближайший аэропорт — Navegantes (15 мин от парка).</p>
      </section>

      <section className="article-section">
        <h2 className="article-subtitle">🎠 Что вас ждёт внутри</h2>

        <div className="article-section">
          <h3 className="article-section-title">🎢 Экстремальные аттракционы</h3>
          <p className="article-text">
            <strong>FireWhip</strong> — головокружительная американская горка.<br />
            <strong>Big Tower</strong> — свободное падение с высоты 100 метров.<br />
            <strong>Star Mountain</strong> — классическая горка с поворотами и скоростью.
          </p>
        </div>

        <div className="article-section">
          <h3 className="article-section-title">👧 Детская зона</h3>
          <p className="article-text">
            Мягкие аттракционы, мини-городок, герои мультфильмов DreamWorks (Шрек, Мадагаскар, Кунг-фу Панда).
          </p>
        </div>

        <div className="article-section">
          <h3 className="article-section-title">🦁 Зоопарк</h3>
          <p className="article-text">
            Более 100 видов животных, включая жирафов, слонов, тигров и ягуаров.
          </p>
        </div>

        <div className="article-section">
          <h3 className="article-section-title">🎭 Шоу</h3>
          <p className="article-text">
            <strong>Velozes e Furiosos (Форсаж)</strong> — дрифт, трюки и дым.<br />
            Шоу с лошадьми и ковбоями — часть оригинальной культуры Бразилии.<br />
            <strong>Teatro Excalibur</strong> — рыцарские турниры и юмор.
          </p>
        </div>
      </section>

      <section className="article-section">
        <h2 className="article-subtitle">💡 Лайфхаки для посещения</h2>
        <div className="article-section">
          <h3 className="article-section-title">1. Покупай билеты заранее</h3>
          <p className="article-text">
            На сайте парка можно сэкономить до 15%. Часто бывают акции — например, второй день бесплатно.
          </p>
        </div>
        <div className="article-section">
          <h3 className="article-section-title">2. Приходи к открытию</h3>
          <p className="article-text">
            Парк большой, и в высокий сезон (лето и каникулы) очереди могут быть длинными.
            Чем раньше начнёшь — тем больше успеешь.
          </p>
        </div>
        <div className="article-section">
          <h3 className="article-section-title">3. Скачай официальное приложение</h3>
          <p className="article-text">
            Там есть карта парка, расписание шоу и время ожидания в очередях.
          </p>
        </div>
        <div className="article-section">
          <h3 className="article-section-title">4. Запланируй шоу заранее</h3>
          <p className="article-text">
            Некоторые проходят один раз в день. Лучше расставить приоритеты утром.
          </p>
        </div>
        <div className="article-section">
          <h3 className="article-section-title">5. Одежда и обувь</h3>
          <p className="article-text">
            Удобная обувь — обязательно. Есть аттракционы, где можно промокнуть, — захвати сменную футболку.
            Солнцезащитный крем и шляпа — must, особенно летом.
          </p>
        </div>
        <div className="article-section">
          <h3 className="article-section-title">6. Еда и напитки</h3>
          <p className="article-text">
            Нельзя проносить еду, но внутри много кафе и ресторанов. Можно взять пустую бутылку
            и пополнять её — фонтаны с питьевой водой есть.
          </p>
        </div>
        <div className="article-section">
          <h3 className="article-section-title">7. Бюджет</h3>
          <p className="article-text">
            Средняя стоимость еды — около 40–60 реалов на человека. Сувениры и фотосессии — дополнительно.
            Есть VIP-пропуска (Fast Pass), чтобы не стоять в очередях — особенно удобно с детьми.
          </p>
        </div>
      </section>

      <section className="article-section">
        <h2 className="article-subtitle">👨‍👩‍👧 Подходит ли детям?</h2>
        <p className="article-text">
          Да! Парк рассчитан на детей всех возрастов — от малышей до подростков. Много тематических зон
          с героями мультфильмов и безопасных аттракционов. Плюс отличные зоны для отдыха и перекуса.
        </p>
      </section>

      <section className="article-section">
        <h2 className="article-subtitle">🎫 Бонус: когда ехать?</h2>
        <p className="article-text">
          Лучшее время — весна и осень (март-май, сентябрь-ноябрь): меньше людей, не так жарко.
        </p>
        <div className="article-note">
          <p className="article-note-text">
            Лето (декабрь–февраль) — красиво, но многолюдно.
          </p>
        </div>
      </section>
    </article>
  );
};

export default BetoCarreroArticle;